<template>
  <div class="uk-flex uk-flex-middle copyEntry">
    <VueSelect
      class="copyEntry__dropdown"
      :options="choices"
      :placeholder="$t('events.copy_from_label')"
      @input="selected"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueSelect from 'vue-select';

@Component({
  components: {
    VueSelect
  }
})
export default class CopyEntry extends Vue {
  @Prop({default: []}) choices!: { value: string, label: string }[];

  selected(e: InputEvent): void {
    this.$emit('selected', e);
  }
}
</script>

<style scoped>
.copyEntry__dropdown {
  width: 250px;
}
</style>
